import axios from "axios";
import { authManager } from "src/main";

export const portalApiClient = axios.create({
  baseURL: process.env.VITE_API_URL,
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Credentials": true,
    "Ocp-Apim-Subscription-Key":
      process.env.VITE_APIM_SUBSCRIPTION_KEY ||
      "feeb84807a9a4d27ba43b5d36062de10",
  },
});

portalApiClient.interceptors.request.use(async (request) => {
  // await authManager.tryLoginSilently();
  if (
    (process.env.VITE_NODE_ENV === "debug" ||
      process.env.VITE_NODE_ENV === "cypress") &&
    !authManager.token
  ) {
    request.headers["X-Api-Key"] = process.env.VITE_API_KEY;
    return request;
  }
  if (sessionStorage.getItem("LOGINCODE")) {
    request.headers["x-api-key"] = sessionStorage.getItem("LOGINCODE") || "";
    return request;
  } else if (!request.url?.includes("blob")) {
    const token = await authManager.getValidToken();
    
    request.headers.Authorization = `Bearer ${token}`;
    request.headers["Ocp-Apim-Subscription-Key"] =
      process.env.VITE_APIM_SUBSCRIPTION_KEY ||
      "feeb84807a9a4d27ba43b5d36062de10";
  }

  return request;
});

portalApiClient.interceptors.response.use(async (response) => {
  if (response.status === 401) {
    if (authManager.token) {
      await authManager.signOut();
      window.location.href = "/login";
    } else {
      return portalApiClient.request(response.config);
    }
  }
  return response;
});
